/*
 * The base error class for UI
 */
class AppError extends Error {
}
/*
 * All derived error clases
 *
 * Note: for some errors, we want to ensure that some custom info is handled by sentry.
 *
 * To ensure data for a particular error type makes it to Datadog, do the following:
 *  1. Define a custom error class for the error type, taking props in the second argument
 *  2. Assign the props to the instance in the constructor
 *  3. Override the `updateDatadogEvent` method to add the props to the event
 *  4. Add the static `create` method, which has required props (the base class constructor options are optional)
 *  5. Update the eslint `no-restricted-syntax` rule to disallow creating the error instance using `new`
 */
export class UnknownError extends AppError {
}
export class WidgetError extends AppError {
    widgetId;
    widgetType;
    workspaceId;
    constructor(message, options) {
        super(message);
        this.widgetId = options.props.widgetId;
        this.widgetType = options.props.widgetType;
        this.workspaceId = options.props.workspaceId;
    }
    static create(message, props) {
        return new this(message, { props });
    }
}
export class UnexpectedTimestampError extends AppError {
    timestamp;
    constructor(message, options) {
        super(message);
        this.timestamp = options.props.timestamp;
    }
    static create(message, props) {
        return new this(message, { props });
    }
}
